import { render, staticRenderFns } from "./professionalTechnique.vue?vue&type=template&id=2cd8cefd"
import script from "./professionalTechnique.vue?vue&type=script&lang=js"
export * from "./professionalTechnique.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports